import React, { Component } from "react";
import "../../../assets/scss/cardTemplate.scss";
import download from "../../../assets/images/cardTemplates/download.png";
import schoolLogo from "../../../assets/images/logo/logo1.png";
import signature from "../../../assets/images/cardTemplates/signature.PNG";

class Template3 extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        className={
          this.props?.mode === "create"
            ? `cardTemplateContainer template3Container`
            : `cardTemplateContainer template3Container listTemp3Container`
        }
        // "cardTemplateContainer template3Container"
      >
        <div data-id={this.props.id} className="front frontTemplate mb-4">
          <div style={{ paddingTop: "10px" }} className="cardTemplateContent">
            <div className="contentTitleFlexDiv">
              <div className="contentTileLogo">
                <img
                  src={
                    this.props.schoolLogo ? this.props.schoolLogo : schoolLogo
                  }
                />
              </div>
              <div className="contentTitleData">
                <p className="contentTitleSchoolName">
                  {this.props.schoolName
                    ? this.props.schoolName
                    : "School Name"}
                </p>
                <p>
                  {this.props.schoolAddress
                    ? this.props.schoolAddress
                    : "School Address"}
                </p>
                <p>
                  {this.props.schoolContact
                    ? this.props.schoolContact
                    : "Tel: Contact Number"}
                </p>
              </div>
            </div>
            <div className="contentDataFlexDiv">
              <div className="contentDataDiv">
                <table className="idTemplate">
                  <tbody>
                    <tr>
                      <th width="30%">Name</th>
                      <th>:</th>
                      <td>
                        {this.props.studentName
                          ? this.props.studentName
                          : "People Name"}
                      </td>
                    </tr>
                    <tr>
                      <th width="30%">Class</th>
                      <th>:</th>
                      <td>
                        {this.props.subtitle
                          ? this.props.subtitle
                          : "Class - Section / Designation"}
                      </td>
                    </tr>
                    {(this.props?.mode === "create" ||
                      this.props.rollNumber) && (
                      <tr>
                        <th width="30%">Roll No.</th>
                        <th>:</th>
                        <td>
                          {this.props.rollNumber
                            ? this.props.rollNumber
                            : "Roll Number"}
                        </td>
                      </tr>
                    )}
                    {(this.props?.mode === "create" ||
                      this.props.dateOfBirth) && (
                      <tr>
                        <th width="30%">DOB</th>
                        <th>:</th>
                        <td>
                          {this.props.dateOfBirth
                            ? this.props.dateOfBirth
                            : "Date of Birth"}
                        </td>
                      </tr>
                    )}
                    <tr>
                      <th width="30%">Address</th>
                      <th>:</th>
                      <td>
                        {this.props.userAddress !== ""
                          ? this.props.userAddress
                          : "----"}
                      </td>
                    </tr>
                    <tr>
                      <th width="30%">EM Contact</th>
                      <th>:</th>
                      <td>
                        <p>
                          {this.props?.emergencyContact?.name &&
                            this.props?.emergencyContact?.name}
                          {this.props?.emergencyContact?.name &&
                            (this.props?.emergencyContact?.contactNumber ||
                              this.props?.emergencyContact?.mobileNumber) &&
                            ", "}
                          {!this.props?.emergencyContact?.name &&
                            (!this.props?.emergencyContact?.contactNumber ||
                              !this.props?.emergencyContact?.mobileNumber) &&
                            "-"}
                          {(this.props?.emergencyContact?.contactNumber ||
                            this.props?.emergencyContact?.mobileNumber) &&
                            (this.props?.emergencyContact?.contactNumber ||
                              this.props?.emergencyContact?.mobileNumber)}
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div className="contentDataDiv2 d-flex align-items-center flex-column justify-content-end">
                <div className="idImageHolder">
                  <img
                    src={this.props.userImage ? this.props.userImage : download}
                    alt="user image"
                  />
                </div>
                <div className="idSignature idSignatureHolder">
                  <img
                    alt="signature"
                    src={
                      this.props?.signature ? this.props?.signature : signature
                    }
                  />
                </div>
                <p
                  className="text-center"
                  style={{
                    wordBreak: "break-all",
                    fontSize: "10px",
                    marginTop: "39px",
                    marginBottom: "0px",
                  }}
                >
                  {this.props.authorizedSignatureName ||
                    "Sample signature Name"}
                </p>
              </div>
            </div>
          </div>
          <div className="idValidDate d-flex align-items-center justify-content-around">
            <p className="validDateCss mb-0">
              <strong>Issued Date: </strong>{" "}
              {this.props.issuedDate ? this.props.issuedDate : "Date"}
            </p>
            <p className="validDateCss mb-0">
              <strong>Valid Until: </strong>
              {this.props.validityDate ? this.props.validityDate : "Date"}
            </p>
          </div>
        </div>
        <br />
        <div data-id={this.props.id} className="back backTemplate">
          {this.props.schoolWebAddress && (
            <p className="topGraident">{this.props.schoolWebAddress}</p>
          )}
          <div
            className={
              this.props?.mode === "create"
                ? "backNote"
                : "backNote backNoteList"
            }
            style={{
              display: "flex",
              flexDirection: "column",
              gap: this.props.schoolWebAddress ? "0px" : "4px",
              height: this.props.schoolWebAddress ? "80%" : "90%",
              padding: this.props.schoolWebAddress ? "12px" : "1rem",
            }}
          >
            <p style={{ marginBottom: "10px" }}>
              This card must be carried at all times and presented upon request.
              This card holder is responsible for use and missuse of this card.
            </p>
            <p style={{ marginBottom: "10px" }} className="warningNoteBack">
              NOT TRANSFERABLE
              <br />
              <span>If found, please return to </span>
            </p>
            <p style={{ fontSize: "14px" }} className="backSchoolTitle">
              <strong>
                {this.props.schoolName ? this.props.schoolName : "School Name"}
              </strong>
            </p>
            <p className="backSchoolData">
              {this.props.schoolAddress
                ? this.props.schoolAddress
                : "School Address"}
            </p>
            <p
              style={{
                position: "absolute",
                marginBottom: "2px",
                bottom: 0,
                left: 0,
                right: 0,
              }}
              className="backSchoolData"
            >
              {this.props.schoolContact
                ? this.props.schoolContact
                : "Tel: Contact Number"}
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default Template3;
